export const environment = {
  realm: "vertex-staging",
  production: true,
  version: '2.6.7' + 'rc',
  exploreURL: 'https://explore-staging.epc-groupe.com',
  vibrationApiURL: 'https://explore-staging.epc-groupe.com/vibration/api',
  keycloakUrl: "https://auth.diogen.net",
  auth: "https://auth.diogen.net",
  logout: 'https://explore-staging.epc-groupe.com',
}; 
